var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__title animated"},[_c('img',{attrs:{"src":_vm.slogan,"alt":"slogan"}})])}
var staticRenderFns = []

export { render, staticRenderFns }